export enum RedemptionActionTypes {
  REDEEMING = 'redemption/REDEEMING',
  REDEEMED = 'redemption/REDEEMED',
  TEST_REQUEST = 'redemption/TEST_REQUEST',
  TEST_SUCCESS = 'redemption/TEST_SUCCESS',
  TEST_ERROR = 'redemption/TEST_ERROR',
}
